<div [class]="'custom-close custom-close-' + variant">
  <span [class]="'custom-cross custom-cross-' + variant"></span>
</div>
